import React from 'react'
import { Link } from 'react-router-dom'
import { companyInfo } from '../data/companyInfo'

const privacySections = [
    {
        title: 'Information We Collect',
        paragraphs: [
            `${companyInfo.name} may collect the personal information that travelers share during inquiry, booking, and support communication, including name, phone number, email address, travel dates, destination preferences, and special travel requirements.`,
            'This information is collected only to plan, confirm, and manage travel services in a professional manner.'
        ]
    },
    {
        title: 'How We Use Information',
        paragraphs: [
            'We use customer information to respond to inquiries, prepare itineraries, confirm bookings, coordinate transport and accommodation, and provide customer support before and during the trip.',
            'We may also use contact details to share booking updates, schedule changes, payment reminders, or operational notices related to the confirmed service.'
        ]
    },
    {
        title: 'Data Sharing',
        paragraphs: [
            'Customer information is not sold to third parties. Limited details may be shared only when necessary with hotels, transport providers, guides, or other service partners involved in delivering the booked package.',
            'Such sharing is limited to operational requirements connected with the travelerâ€™s requested service.'
        ]
    },
    {
        title: 'Communication Channels',
        paragraphs: [
            `Travelers may contact ${companyInfo.name} through phone, email, WhatsApp, or website forms. Messages received through these channels are used for service communication and booking support.`,
            'Customers should avoid sending unnecessary sensitive personal documents unless they are specifically required for a booking or permit process.'
        ]
    },
    {
        title: 'Data Security',
        paragraphs: [
            'Reasonable care is taken to protect booking and inquiry information from unauthorized access, misuse, or disclosure.',
            'However, no online communication or digital storage method can be guaranteed as completely risk-free, so users share information with normal internet communication understanding.'
        ]
    },
    {
        title: 'Policy Updates',
        paragraphs: [
            'This privacy policy may be updated whenever business operations, booking processes, or legal requirements change.',
            `For any question about privacy handling, travelers may contact ${companyInfo.contactPerson} using the contact information listed below.`
        ]
    }
]

function PrivacyPolicyContent() {
    return (
        <section className="space-top space-extra-bottom">
            <div className="container shape-mockup-wrap">
                <div className="row justify-content-center">
                    <div className="col-xl-8">
                        <div className="title-area text-center">
                            <span className="sub-title">Data & Communication</span>
                            <h2 className="sec-title">Privacy Policy</h2>
                            <p>
                                This policy explains how {companyInfo.name} collects, uses, and protects customer information.
                            </p>
                        </div>
                    </div>
                </div>

                <div className="row gy-4">
                    <div className="col-lg-8">
                        <div className="page-single">
                            <div className="page-content d-block">
                                {privacySections.map((section) => (
                                    <div key={section.title} className="mb-40">
                                        <h3 className="box-title">{section.title}</h3>
                                        {section.paragraphs.map((paragraph, index) => (
                                            <p className="box-text mb-20" key={index}>
                                                {paragraph}
                                            </p>
                                        ))}
                                    </div>
                                ))}

                                <div className="destination-checklist mt-50 mb-40">
                                    <div className="checklist style2 style4">
                                        <ul>
                                            <li>Inquiry and booking details are used for service delivery</li>
                                            <li>Operational partners receive only required trip information</li>
                                            <li>Customer data is not sold for marketing resale</li>
                                            <li>Support communication may happen by phone, email, or WhatsApp</li>
                                        </ul>
                                    </div>
                                    <div className="checklist style5">
                                        <ul>
                                            <li>Share only relevant information for your booking</li>
                                            <li>Policy may be updated when operations change</li>
                                            <li>Travelers can contact the company for clarification</li>
                                            <li>Normal digital communication limits still apply</li>
                                        </ul>
                                    </div>
                                </div>

                                <div className="contact-feature">
                                    <div className="box-icon">
                                        <i className="fa-light fa-location-dot" />
                                    </div>
                                    <div className="media-body">
                                        <p className="contact-feature_label">Office Address</p>
                                        <Link to="/contact" className="contact-feature_link">
                                            {companyInfo.addressFull}
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-4">
                        <aside className="sidebar-area">
                            <div className="widget widget_offer" style={{ background: 'url(/assets/img/bg/widget_bg_1.jpg)' }}>
                                <div className="offer-banner">
                                    <div className="offer">
                                        <h6 className="box-title">Need help with data or booking questions?</h6>
                                        <div className="banner-logo">
                                            <img src="/assets/img/primary-logo.png" alt="Himolan Peak Adventures" />
                                        </div>
                                        <div className="offer">
                                            <h6 className="offer-title">Contact {companyInfo.contactPerson}</h6>
                                            <Link className="offter-num" to={`tel:${companyInfo.phoneDial}`}>
                                                {companyInfo.phoneDisplay}
                                            </Link>
                                        </div>
                                        <p className="box-text text-white mb-2">{companyInfo.email}</p>
                                        <p className="box-text text-white mb-20">{companyInfo.addressShort}</p>
                                        <Link to="https://wa.me/03479020168?text=Assalam%20o%20Alaikum%21%20I%20want%20to%20book%20a%20tour%20with%20Himolan%20Peak%20Adventures." className="th-btn style2 th-icon">
                                            Contact Us
                                        </Link>
                                    </div>
                                </div>
                            </div>

                            <div className="widget widget_categories">
                                <h3 className="widget_title">Policy Links</h3>
                                <ul>
                                    <li>
                                        <Link to="/terms-and-conditions">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                            Terms &amp; Conditions
                                        </Link>
                                        <span>(Policy)</span>
                                    </li>
                                    <li>
                                        <Link to="/faq">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                            FAQ
                                        </Link>
                                        <span>(Help)</span>
                                    </li>
                                    <li>
                                        <Link to="/contact">
                                            <img src="/assets/img/theme-img/map.svg" alt="" />
                                            Contact Us
                                        </Link>
                                        <span>(Support)</span>
                                    </li>
                                </ul>
                            </div>
                        </aside>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default PrivacyPolicyContent

